import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderArrowUp } from '@fortawesome/pro-solid-svg-icons';

import { Button } from 'components/ui/button';

const NEW_UPLOAD_SIGNED_CA_MESSAGE = 'Drag & Drop CA here';

export function CaDropzone({ existingFileName, isDisabled, onFileSelected }) {
  const [file, setFile] = useState(null);

  const handleDrop = (files) => {
    const file = files[0];
    onFileSelected(file);
    // TODO: `file` should probably be a prop, but check all usages
    // Issue: When rendered inside `SignedCA`, React warns: "Can't perform a React state update on an unmounted
    // component", likely because `onFileSelected` unmounts CaDropzone to show the upload spinner.
    setFile(file);
  };

  const defaultMessage = NEW_UPLOAD_SIGNED_CA_MESSAGE;

  const message = (file && file.name) || existingFileName || defaultMessage;

  return (
    <Dropzone
      accept={'.pdf'}
      disabled={isDisabled()}
      multiple={false}
      name={'ca-uploader'}
      onDrop={handleDrop}
    >
      {({ getRootProps, getInputProps }) => (
        <React.Fragment>
          <div {...getRootProps()} className="media-uploader text-center">
            <div><FontAwesomeIcon className="mb-4 text-seagull-600" icon={faFolderArrowUp} size="2x"/></div>
            <div name="dz-title"><strong>{message}</strong></div>
            <div className="mb-1">or</div>
            <Button label="Browse Files" variant="outline" />
          </div>
          <input {...getInputProps()} />
        </React.Fragment>
      )}
    </Dropzone>
  );
}

CaDropzone.propTypes = {
  existingFileName: PropTypes.string,
  isDisabled: PropTypes.func,
  onFileSelected: PropTypes.func.isRequired
};

export default connect(null)(CaDropzone);
